import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { ERdvService } from '../../Services';

interface IERdvConfirmationWidgetProps {
    dictConfirmationTitle1: string;
    dictConfirmationTitle2: string;
    dictConfirmationTitle3: string;
    dictConfirmationDesc1: string;
    dictConfirmationDesc2: string;
    dictConfirmationDesc3: string;
    dictConfirmationDesc4: string;
    dictConfirmationDesc5: string;
    dictConfirmationDesc6: string;
    dictConfirmationDesc7: string;
    dictConfirmationDesc8: string;
    dictConfirmationDesc9: string;
    dictConfirmationDesc10: string;
    dictConfirmationDesc11: string;
    dictCodeRdvLabel: string;
    dictServiceLabel: string;
    dictSiteLabel: string;
    dictDateLabel: string;
    dictHoursLabel: string;
    dictConfirmationInfo1: string;
    dictConfirmationInfo2: string;
    dictConfirmationHelp: string;
    dictAgencyDesc: string;
    dictNameLabel: string;
    dictSurnameLabel: string;
    dictNissLabel: string;
    dictPostCodeLabel: string;
    dictPhoneLabel: string;
    dictMailLabel: string;

    code: { key: number; label: string };
    service: { key: string; label: string };
    site: { key: string; label: string };
    timing: { date: Date; hoursStart: string; hoursEnd: string };
    comment: string;
    ressource: { id: number; key: string; type: string };
    user: {
        civilite: number;
        niss: string;
        nom: string;
        prenom: string;
        telephone: string;
        mail: string;
    };
    handleNavTo: (val: number) => void;
    resetDatas: () => void;
    lang: string;
    captchaToken: string;
}

interface IERdvConfirmationWidgetState {
    codeRdv: string;
    title: string;
    name: string;
    surname: string;
    date: Date;
    hoursStart: string;
    site: string;
    service: string;
    niss: string;
    phone: string;
    mail: string;
}

export class ERdvConfirmationWidget extends Component<
    IERdvConfirmationWidgetProps,
    IERdvConfirmationWidgetState
> {
    constructor(props: IERdvConfirmationWidgetProps) {
        super(props);
        this.state = {
            codeRdv: null as any,
            title:
                this.props.lang === 'fr'
                    ? this.props.user.civilite === 0
                        ? 'Monsieur'
                        : 'Madame'
                    : this.props.user.civilite === 0
                      ? 'Meneer'
                      : 'Mevrouw',
            name: this.props.user.nom,
            surname: this.props.user.prenom,
            date: this.props.timing.date,
            hoursStart: this.props.timing.hoursStart,
            site: this.props.site.label,
            service: this.props.service.label,
            phone: this.props.user.telephone,
            mail: this.props.user.mail,
            niss: this.props.user.niss,
        };

        void ERdvService.takeAppointment(
            this.props.timing.date,
            this.props.timing.hoursStart,
            this.props.timing.hoursEnd,
            this.props.service.key,
            this.props.site.key,
            this.props.code.key,
            this.props.comment,
            this.props.ressource,
            this.props.user,
            this.props.captchaToken
        ).then((result: any) => {
            if (result !== 'error') {
                this.setState({ codeRdv: result.code });
                this.props.resetDatas();
            } else {
                this.props.handleNavTo(3);
            }
        });
    }

    render() {
        const bgBlue = {
            backgroundColor: 'aliceblue',
            fontSize: '125%',
        } as React.CSSProperties;

        const fontSize80 = {
            fontSize: '80%',
        } as React.CSSProperties;

        const fgRed = {
            color: 'Red',
        } as React.CSSProperties;

        return (
            <div className="row">
                <div className="container">
                    <div className="row">
                        <div className="offset-md-2 col-md-8">
                            <div className="row px-2">
                                <div className="col-12">
                                    <h2>{this.props.dictConfirmationTitle1}</h2>
                                </div>
                            </div>
                            <div className="row px-2">
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-12">
                                            {this.state.title} {this.state.name}{' '}
                                            {this.state.surname}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            {this.props.dictConfirmationDesc1}{' '}
                                            <strong>
                                                {this.state.date.toLocaleDateString()}{' '}
                                                {
                                                    this.props
                                                        .dictConfirmationDesc2
                                                }{' '}
                                                {this.state.hoursStart}{' '}
                                            </strong>{' '}
                                            {this.props.dictConfirmationDesc3}{' '}
                                            {this.state.site}.
                                            <br />
                                            {this.props.dictConfirmationDesc4}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <h2>
                                                {
                                                    this.props
                                                        .dictConfirmationTitle3
                                                }
                                            </h2>
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-4">
                                            <strong>
                                                {this.props.dictCodeRdvLabel}
                                            </strong>
                                        </div>
                                        <div className="col-8">
                                            {this.state.codeRdv}
                                        </div>
                                    </div>

                                    <div className="row my-3">
                                        <div className="col-4">
                                            <strong>
                                                {this.props.dictSiteLabel}
                                            </strong>
                                        </div>
                                        <div className="col-8">
                                            {this.state.site}
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-4">
                                            <strong>
                                                {this.props.dictDateLabel}
                                            </strong>
                                        </div>
                                        <div className="col-8">
                                            {this.state.date.toLocaleDateString()}
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-4">
                                            <strong>
                                                {this.props.dictHoursLabel}
                                            </strong>
                                        </div>
                                        <div className="col-8">
                                            {this.state.hoursStart}
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div
                                            className="col-12 font-weight-bold"
                                            style={fgRed}
                                        >
                                            {this.props.dictConfirmationDesc9}{' '}
                                            <br />
                                            {this.props.dictConfirmationDesc10}
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-4">
                                            <strong>
                                                {this.props.dictServiceLabel}
                                            </strong>
                                        </div>
                                        <div className="col-8">
                                            {this.state.service}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-12">
                                            <h2>
                                                {
                                                    this.props
                                                        .dictConfirmationDesc11
                                                }
                                            </h2>
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-4">
                                            <strong>
                                                {this.props.dictNameLabel}
                                            </strong>
                                        </div>
                                        <div className="col-8">
                                            {this.state.name}
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-4">
                                            <strong>
                                                {this.props.dictSurnameLabel}
                                            </strong>
                                        </div>
                                        <div className="col-8">
                                            {this.state.surname}
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-4">
                                            <strong>
                                                {this.props.dictNissLabel}
                                            </strong>
                                        </div>
                                        <div className="col-8">
                                            {this.state.niss}
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-4">
                                            <strong>
                                                {this.props.dictPhoneLabel}
                                            </strong>
                                        </div>
                                        <div className="col-8">
                                            {this.state.phone}
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-4">
                                            <strong>
                                                {this.props.dictMailLabel}
                                            </strong>
                                        </div>
                                        <div className="col-8">
                                            {this.state.mail}
                                        </div>
                                    </div>

                                    <div className="row my-3">
                                        <div className="col-12">
                                            <h2>
                                                {
                                                    this.props
                                                        .dictConfirmationTitle2
                                                }
                                            </h2>
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-12">
                                            {this.props.dictConfirmationDesc5}{' '}
                                            <strong>0800 35 123</strong>.
                                        </div>
                                    </div>
                                    <div className="row my-3">
                                        <div className="col-12">
                                            {this.props.dictConfirmationDesc6}
                                        </div>
                                    </div>
                                    <div className="row my-3 mt-5">
                                        <div className="col-12">
                                            {this.props.dictConfirmationDesc7}{' '}
                                            <br />{' '}
                                            {this.props.dictConfirmationDesc8}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div
                                            className="col-12 text-center"
                                            style={fontSize80}
                                        >
                                            {this.props.dictConfirmationHelp}
                                        </div>
                                    </div>
                                </div>
                                <div className="row ml-n3 w-100">
                                    <div
                                        className="col-md-12 h-100 p-5 m-md-4 text-center"
                                        style={bgBlue}
                                    >
                                        {this.props.dictConfirmationInfo1}.{' '}
                                        <br />
                                        {
                                            this.props.dictConfirmationInfo2
                                        } : <br />
                                        <strong>{this.state.codeRdv}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

WidgetHelper.register(ERdvConfirmationWidget, 'erdv-confirmation-widget');
